export default __webpack_public_path__ + "static/media/arrow_right_white.2a33d589.svg";